import { useMediaQuery } from '@mui/material';
import VerifyCodeAmplify from 'features/Authentication/VerifyCode/VerifyCode';
import AuthLayout from 'layouts/AuthLayout';
import theme from 'themes';

const PasswordVerify = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <AuthLayout title='Check Your Email' isMobile={isMobile}>
      <VerifyCodeAmplify />
    </AuthLayout>
  );
};

export default PasswordVerify;
